import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=685f5203&scoped=true&"
var script = {}
import style0 from "./ActionButton.scss?vue&type=style&index=0&id=685f5203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../home/gitlab-runner/.nvm/versions/node/v12.14.1/lib/node_modules/@briskly/vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f5203",
  null
  
)

export default component.exports